import request from "@/utils/request";
// import { encryptByDES } from '@/utils/crypto'
import qs from "qs";
import axios from "axios";
const BASE_API = process.env.VUE_APP_BASE_API;
const LOGIN_API = process.env.VUE_APP_LOGIN_API;
const host = window.location.host
let inspirationApi = ''
if (host == 'social.mktindex.com') {
  inspirationApi = 'https://cmi.mktindex.com'
} else {
  inspirationApi = 'https://cmitest.mktindex.com'
}
const CMI_BASE_API = inspirationApi


export function catSearch(param) {
  return request({
    url: `${BASE_API}/api/cat_search`,
    method: "get",
    params: param,
  });
}
export function getNav(param) {
  return request({
    url: `${BASE_API}/api/navigation`,
    method: "get",
    params: param,
  });
}
export function setNav(data) {
    return request({
      url: `${BASE_API}/api/navigation`,
      method: "PUT",
      data,
    });
}
export function subCustomAnalyse(data) {
  return request({
    url: `${BASE_API}/api/custom_analyse`,
    method: "PUT",
    data,
  });
}
export function editCustomAnalyse(data) {
  return request({
    url: `${BASE_API}/api/custom_analyse`,
    method: "PATCH",
    data,
  });
}
export function getCustomAnalyse(param) {
  return request({
    url: `${BASE_API}/api/custom_analyse`,
    method: "get",
    params: param,
  });
}
export function deleteCustomAnalyse(data) {
  return request({
    url: `${BASE_API}/api/custom_analyse`,
    method: "DELETE",
    data,
  });
}

export function postCustomPublish(param){
  return request({
    url: `${CMI_BASE_API}/api/custom_publish`,
    method: "post",
    data: param
  })
}